
























































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch, Mixins } from 'vue-property-decorator';
import axios from 'axios';
import { api } from '@/api';
import SessionMixin from '@/mixins/session';
import { Debounce } from 'lodash-decorators';

@Component
export default class SessionDetails extends Mixins(SessionMixin) {
  public session: any = {
    babysitter: {
      full_name: '',
    },
    family: {
      family_name: '',
    },
    children: [],
    invites: [],
    applications: [],
    preferred_babysitter_ranks: {},
    babysitter_history: [],
    session_started_at: '',
    session_ended_at: '',
    note: '',
    created_at: '',
    updated_at: '',
    address: {},
  };

  public sessionLoading: boolean = false;
  public sessionProcessing: boolean = false;

  public selectedBabysitter: number | null = null;

  public babysitterName: string = '';
  public babysitterRules: ((v: number) => void)[] = [
    (v: number) => !!v || 'Babysitter is required',
  ];

  public isValid: boolean = false;

  public babysitters: any[] = [];
  public babysitterLoading: boolean = false;

  public confirmationDialog: boolean = false;
  public cancellationDialog: boolean = false;

  @Prop() dialog!: boolean;
  @Prop() sessionId!: any;

  get isMobile() {
    return this.$vuetify.breakpoint.xsOnly;
  }

  get inviteHeaders() {
    const headers: any[] = [
      { text: '', value: 'action', sortable: false, width: '40px' },
      { text: 'Name', value: 'name', sortable: true },
      {
        text: 'Rank',
        value: 'rank',
        sortable: false,
        width: '60px',
        align: 'center',
      },
      { text: 'Source', value: 'source', sortable: false, width: '80px' },
    ];
    if (!this.isMobile) {
      headers.push({ text: 'Date', value: 'created_at', sortable: true });
    }
    headers.push({
      text: 'Status',
      value: 'status',
      sortable: true,
      width: '90px',
    });
    return headers;
  }

  get applicantHeaders() {
    const headers: any[] = [
      { text: '', value: 'action', sortable: false, width: '40px' },
      { text: 'Name', value: 'name', sortable: true },
      {
        text: 'Rank',
        value: 'rank',
        sortable: false,
        width: '60px',
        align: 'center',
      },
    ];
    if (!this.isMobile) {
      headers.push({ text: 'Date', value: 'created_at', sortable: true });
    }
    headers.push({
      text: 'Status',
      value: 'status',
      sortable: true,
      width: '90px',
    });
    return headers;
  }

  get invitesList() {
    const rawInvites = this.normalizeList(this.session.invites);
    const rawHistory = this.normalizeList(this.session.babysitter_history);
    return this.processUnifiedList(rawInvites, rawHistory);
  }

  get applicantsList() {
    const rawApps = this.normalizeList(this.session.applications);
    return this.processUnifiedList(rawApps, []);
  }

  normalizeList(data: any): any[] {
    if (!data) return [];
    return Array.isArray(data) ? data : Object.values(data);
  }

  processUnifiedList(invites: any[], history: any[]) {
    const ranks = this.session.preferred_babysitter_ranks || {};
    const result: any[] = [];

    // History dates arrive from the API without a year ("Jun - 08 / 18:13"),
    // while invites/applications carry full dates. Infer the year for the
    // year-less history entries from the invites we can see.
    const referenceYear = this.deriveReferenceYear(invites);
    const anchorTimestamp = this.latestInviteTimestamp(invites);

    // Process invites — group by babysitter to track latest
    const groups: { [key: number]: any[] } = {};
    invites.forEach((item: any) => {
      const id = item.babysitter.id;
      if (!groups[id]) groups[id] = [];
      groups[id].push(item);
    });

    Object.values(groups).forEach((group) => {
      group.sort(
        (a, b) =>
          this.toTimestamp(b.created_at) - this.toTimestamp(a.created_at),
      );
      group.forEach((item, index) => {
        const isLatest = index === 0;
        result.push({
          id: item.babysitter.id,
          name: item.babysitter.name,
          rank: ranks[item.babysitter.id] ?? null,
          state: item.state,
          created_at: item.created_at,
          ts: this.toTimestamp(item.created_at),
          isLatest: isLatest,
          entryType: 'invite',
          source: item.is_admin_invite ? 'admin' : 'parent',
          radioValue: isLatest
            ? item.babysitter.id
            : `disabled_${item.babysitter.id}_${index}`,
        });
      });
    });

    // Process history entries (cancellations)
    history.forEach((item: any) => {
      result.push({
        id: item.babysitter.id,
        name: item.babysitter.name,
        rank: ranks[item.babysitter.id] ?? null,
        state: 'canceled',
        created_at: item.created_at,
        ts: this.parseHistoryTimestamp(
          item.created_at,
          referenceYear,
          anchorTimestamp,
        ),
        isLatest: false,
        entryType: 'history',
        source: null,
        note: item.note,
        parent_notified: item.parent_notified,
        radioValue: `history_${item.id}`,
      });
    });

    const sorted = result.sort((a, b) => {
      const diff = b.ts - a.ts;
      if (diff !== 0) return diff;
      if (a.state === 'canceled' && b.state !== 'canceled') return -1;
      if (b.state === 'canceled' && a.state !== 'canceled') return 1;
      return 0;
    });

    // Newest cancellation across ALL babysitters/sources. This is the dividing
    // line: any invite/application created before it belongs to a superseded
    // round and should be faded, no matter who it came from.
    let latestCanceledTimestamp = -Infinity;
    sorted.forEach((item) => {
      if (item.state !== 'canceled') return;
      if (item.ts > latestCanceledTimestamp) latestCanceledTimestamp = item.ts;
    });

    const seenBabysitters = new Set<number>();
    return sorted.map((item) => {
      const hasCancellationAfterOrAt =
        item.state !== 'canceled' &&
        latestCanceledTimestamp !== -Infinity &&
        latestCanceledTimestamp >= item.ts;

      const isLatestOverall = !seenBabysitters.has(item.id);
      seenBabysitters.add(item.id);
      return {
        ...item,
        isLatestOverall,
        hasCancellationAfterOrAt,
      };
    });
  }

  public isInviteRowFaded(item: any): boolean {
    // A cancellation newer than this entry supersedes it — fade it, no matter
    // who created the invite/application.
    if (item.hasCancellationAfterOrAt) return true;

    // Cancellation markers themselves are historical events — always faded.
    if (item.entryType === 'history' || item.state === 'canceled') return true;

    // Entries created after the latest cancellation (or when none happened):
    // keep the live accepted/active one prominent, fade superseded duplicates.
    const isAcceptedOrActive =
      item.state === 'accepted' || item.state === 'active';
    return !(item.isLatestOverall && isAcceptedOrActive);
  }

  // Most recent full-date timestamp among the invites/applications. Used as an
  // anchor to resolve the year of the year-less history dates.
  private latestInviteTimestamp(invites: any[]): number {
    let max = 0;
    invites.forEach((item: any) => {
      const ts = this.toTimestamp(item.created_at);
      if (ts > max) max = ts;
    });
    return max;
  }

  // Year to assume for the year-less history dates: the newest year seen among
  // the (fully-dated) invites, falling back to the current year.
  private deriveReferenceYear(invites: any[]): number {
    let year = 0;
    invites.forEach((item: any) => {
      const ts = this.toTimestamp(item.created_at);
      if (ts) {
        const y = new Date(ts).getFullYear();
        if (y > year) year = y;
      }
    });
    return year || new Date().getFullYear();
  }

  // Parses the API's year-less history date ("Jun - 08 / 18:13") into a
  // millisecond timestamp, inferring the year so it lands after the invites it
  // supersedes (handles the Dec → Jan boundary).
  private parseHistoryTimestamp(
    value: any,
    referenceYear: number,
    anchor: number,
  ): number {
    if (typeof value !== 'string') return this.toTimestamp(value);

    const match = value.match(
      /([A-Za-z]{3})\s*-\s*(\d{1,2})\s*\/\s*(\d{1,2}):(\d{2})/,
    );
    if (!match) return this.toTimestamp(value);

    const monthMap: { [key: string]: number } = {
      jan: 0,
      feb: 1,
      mar: 2,
      apr: 3,
      may: 4,
      jun: 5,
      jul: 6,
      aug: 7,
      sep: 8,
      oct: 9,
      nov: 10,
      dec: 11,
    };

    const month = monthMap[match[1].toLowerCase()];
    if (month === undefined) return this.toTimestamp(value);

    const day = parseInt(match[2], 10);
    const hour = parseInt(match[3], 10);
    const minute = parseInt(match[4], 10);

    const build = (year: number) =>
      new Date(year, month, day, hour, minute, 0, 0).getTime();

    let ts = build(referenceYear);

    // A cancellation always happens after the invite it supersedes. If the
    // reference year places it far before the latest invite, the real event
    // wrapped into the next year (invite in Dec, cancellation in Jan), and
    // vice versa.
    const SIX_MONTHS = 1000 * 60 * 60 * 24 * 182;
    if (anchor && anchor - ts > SIX_MONTHS) ts = build(referenceYear + 1);
    else if (anchor && ts - anchor > SIX_MONTHS) ts = build(referenceYear - 1);

    return ts;
  }

  private toTimestamp(value: any): number {
    if (typeof value === 'number') return value;
    if (value instanceof Date) return value.getTime();
    if (typeof value !== 'string') return 0;

    const parsed = Date.parse(value);
    if (!Number.isNaN(parsed)) return parsed;

    const match = value.match(
      /^(\d{1,2})\.\s*([A-Za-z]{3})\s*(\d{2,4})\s*-\s*(\d{1,2}):(\d{2})$/,
    );
    if (!match) return 0;

    const day = parseInt(match[1], 10);
    const monthAbbr = match[2].toLowerCase();
    const rawYear = parseInt(match[3], 10);
    const hour = parseInt(match[4], 10);
    const minute = parseInt(match[5], 10);

    const monthMap: { [key: string]: number } = {
      jan: 0,
      feb: 1,
      mar: 2,
      apr: 3,
      may: 4,
      jun: 5,
      jul: 6,
      aug: 7,
      sep: 8,
      oct: 9,
      nov: 10,
      dec: 11,
    };

    const month = monthMap[monthAbbr];
    if (month === undefined) return 0;

    const year = rawYear < 100 ? 2000 + rawYear : rawYear;
    return new Date(year, month, day, hour, minute, 0, 0).getTime();
  }

  public stateColor(state: string): string {
    switch (state) {
      case 'confirmed':
        return 'success';
      case 'canceled':
        return 'error';
      case 'requested':
      case 'listed':
        return 'warning';
      case 'active':
        return 'info';
      case 'finished':
        return 'blue-grey';
      default:
        return 'grey';
    }
  }

  public rankColor(rank: number): string {
    if (rank === 1) return 'amber darken-2';
    if (rank === 2) return 'blue-grey';
    if (rank === 3) return 'brown lighten-1';
    return 'blue-grey lighten-3';
  }

  @Watch('dialog', { immediate: true })
  onDialogOpen(opened: any) {
    if (opened && this.sessionId) {
      this.loadDetails();
    }
  }

  public inviteColor(state: string): string {
    switch (state) {
      case 'accepted':
      case 'active':
        return 'success';
      case 'declined':
      case 'canceled':
        return 'error';
      case 'expired':
        return 'grey';
      case 'pending':
        return 'warning';
      default:
        return 'primary';
    }
  }

  public confirmSession() {
    this.confirmationDialog = false;
    this.sessionProcessing = true;

    axios
      .post(api.path('v1.admin.sessions.confirm', { id: this.sessionId }), {
        babysitter_id: this.selectedBabysitter,
      })
      .then((res) => {
        this.$toast.success(res.data['message']);
        this.$emit('update', {
          id: this.sessionId,
          babysitter: {
            id: this.selectedBabysitter,
            full_name: this.babysitterName,
          },
          state: 'confirmed',
        });
        this.close();
      })
      .finally(() => (this.sessionProcessing = false));
  }

  public cancelSession() {
    this.cancellationDialog = false;
    this.sessionProcessing = true;

    axios
      .post(api.path('v1.admin.sessions.cancel', { id: this.sessionId }))
      .then((res) => {
        this.$toast.success(res.data['message']);
        this.$emit('update', {
          id: this.sessionId,
          babysitter: {
            id: this.selectedBabysitter,
            full_name: this.babysitterName,
          },
          state: 'canceled',
        });
        this.close();
      })
      .finally(() => (this.sessionProcessing = false));
  }

  public cancelSessionAsFamily() {
    this.cancellationDialog = false;
    this.sessionProcessing = true;

    axios
      .post(api.path('v1.admin.sessions.cancelFamily', { id: this.sessionId }))
      .then((res) => {
        this.$toast.success(res.data['message']);
        this.$emit('update', {
          id: this.sessionId,
          babysitter: {
            id: this.selectedBabysitter,
            full_name: this.babysitterName,
          },
          state: 'canceled',
        });
        this.close();
      })
      .finally(() => (this.sessionProcessing = false));
  }

  public cancelSessionAsBabysitter() {
    this.cancellationDialog = false;
    this.sessionProcessing = true;

    axios
      .post(
        api.path('v1.admin.sessions.cancelBabysitter', { id: this.sessionId }),
      )
      .then((res) => {
        this.$toast.success(res.data['message']);
        this.$emit('update', {
          id: this.sessionId,
          babysitter: {
            id: this.selectedBabysitter,
            full_name: this.babysitterName,
          },
          state: 'canceled',
        });
        this.close();
      })
      .finally(() => (this.sessionProcessing = false));
  }

  async inviteSitters() {
    this.sessionProcessing = true;
    try {
      const result = await axios.put(
        api.path('v1.admin.sessions.invite', { id: this.sessionId }),
        {
          babysitter_ids: [this.selectedBabysitter],
        },
      );
      this.$toast.success(result.data['message']);
      this.loadDetails(5000);
    } catch (error) {
      console.error('Error inviting sitters:', error);
      this.$toast.error((error as any).data['message']);
    } finally {
      this.sessionProcessing = false;
    }
  }

  public close() {
    this.$emit('update:dialog', !this.dialog);
    this.selectedBabysitter = null;
    this.sessionLoading = true;
    this.sessionProcessing = false;
  }

  @Watch('babysitterName')
  @Debounce(500)
  onBabysitterNameChange(value: string): void {
    let params = {
      paginate: 'no',
      babysitter: value,
      potential_babysitter: false,
    };
    this.babysitterLoading = true;

    axios
      .get(api.path('v1.admin.babysittersAll'), { params: params })
      .then((res) => {
        this.babysitterLoading = false;
        this.babysitters = res.data.data;
      });
  }

  public loadDetails(delay = 0) {
    this.sessionLoading = true;
    setTimeout(() => {
      axios
        .get(api.path('v1.admin.sessions.single', { id: this.sessionId }))
        .then((res) => {
          this.session = res.data.data;
          this.sessionLoading = false;
        });
    }, delay);
  }
}
